export default "__VITE_ASSET__xMFv6SwJ__"